import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { useAuthStore } from './store/authStore'
import './index.css'

// Initialize auth on app load
if (typeof window !== 'undefined') {
  const token = localStorage.getItem('access_token');
  if (token) {
    useAuthStore.getState().fetchMe();
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)